import { LoadingView } from '@app/components/Loading';
import { LOCAL_STORAGE_USER_LOGIN_INFO } from '@app/constants/Common';
import CddSddvListTable from "@pages/dvtjcuv/list/cddsddv/CddSddvListTable";
import React, { useEffect, useState } from 'react';
import {ServiceStatuses} from "@pages/candidate/detail/CandidateDVTJCUV";
import { DVTJCUVCddSddvParentTabs } from "@pages/dvtjcuv/common/CddSddvTabs";
import { requestGetCddSddvList } from '@app/services/CddSddvService';


const CddSddvContent = (props) => {
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [candidates, setCandidates] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [numberPages, setNumberPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const {parentTab} = props;

    useEffect(() => {
        let loginUser = {};
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO));
            setUserLoginInfo(loginUser);
        }
    }, []);

    const searchCandidates = () => {
        
        // console.log('serviceUseStatus:', serviceUseStatus)
        requestGetCddSddvList({parent_tab: parentTab.id}).then((res) => {
            setCandidates(res.content.candidates);
            // setTotalCount(res.content.totalCount)
            // setCurrentPage(res.content.page)
            // setNumberPages(Math.floor(Number(res.content.totalCount) / DEFAULT_PAGE_SIZE) + 1);
        })
    }

    useEffect(() => {
        searchCandidates()
    }, []);

    // const fetchPipeLines = async (pTab, subTab, sorts) => {
    //     const params = {
    //         search_conditions: {
    //             parent_tab: pTab?.id,
    //             sub_tab: subTab?.id || DVTJCUVCddOpenAndNotSddvBriefSentTabs.OFFERING_TAB.id,
    //             unlimited: true
    //         },
    //         sort_columns: sorts || {
    //             created_date_time: ORDER_BY.DESC_UPDATE_DATE
    //         }
    //     };

    //     const res = await requestGetDVTJCUVPipeLineList(params);
    //     const resContent = res.content;

    //     setPipelineList(resContent.pipelines);
    // };

    // const setTabContents = (pTab) => {
    //     let currTab = {};
    //     let childTabs = [];
        
    //     // if (pTab.id === DVTJCUVCddSddvParentTabs.USDING_SDDV_TAB.id) {
    //     //     currTab = {...DVTJCUVCddSddvBriefSentTabs.OFFERING_TAB};
    //     //     childTabs = Object.values(DVTJCUVCddSddvBriefSentTabs);
    //     // } else if (pTab.id === DVTJCUVCddSddvParentTabs.PAUSE_SDDV_TAB.id) {
    //     //     currTab = {...DVTJCUVCddSddvNeedToMakeBriefTabs.NOT_HAVE_BRIEF_TAB};
    //     //     childTabs = Object.values(DVTJCUVCddSddvNeedToMakeBriefTabs);
    //     // }

    //     setParentOfTab(pTab);
    //     setCurrentTab(currTab);
    //     setChildTabList(childTabs);
    // };

    // useEffect(() => {
    //     if (parentTab) {
    //         fetchPipeLines(parentTab);
    //         setTabContents(parentTab);
    //     }
    //     if (data) {
    //         setDataInfo(data);
    //     }
    // }, [data, parentTab]);

    // const onTabClicked = async (tab) => {
    //     setCurrentTab({...tab});
    //     await fetchPipeLines(parentTab, tab);
    // };

    // const activeTab = (tab) => {
    //     if (currentTab.id === tab.id) {
    //         return 'active';
    //     }
    //     return '';
    // };

    // const onShowEditPipeline = (item, fromReferee) => {
    //     item.fromReferee = !!fromReferee;
    //     setSelectPipeline({...item});
    //     setShowUpdatePipelineModal(true);
    // };

    // const onInputGPEmpDiscussion = () => {
    //     setShowInputCddGPEmpDiscussion(true);
    // };

    // const onSort = async (columnKey) => {
    //     let newSorts = {...sortColumns};
    //     if (newSorts[columnKey] && newSorts[columnKey] === ORDER_BY.ASC) {
    //         newSorts[columnKey] = ORDER_BY.DESC;
    //     } else {
    //         newSorts = {};
    //         newSorts[columnKey] = ORDER_BY.ASC;
    //     }
    //     setSortColumns(newSorts);
    //     await fetchPipeLines(parentTab, currentTab, newSorts);
    // };

    return (
        <>
            <div className="container-fluid">
                <div className="card card-default mt-3">
                    <div className="card-header">
                        <h3 className="card-title"><b>{parentTab.title}</b></h3>
                        {/* <div className={"card-tools row"}>
                            {parentOfTab.id !== DVTJCUVCddOpenAndNotSddvParentTabs.BRIEF_SENT_TAB.id &&
                                <HeaderSearchButtons
                                    parentTabId={parentTab.id}
                                    tabId={currentTab.id}
                                    showBtnSearchPipeline
                                    showBtnSearchCdd
                                    showBtnSearchReceiver
                                />
                            }
                        </div> */}
                    </div>

                    <div className="card-body p-0">
                        <div style={{position: 'relative'}}>
                            {/*<SearchConditionInputModal isShow={showSearchInputModal}*/}
                            {/*                           onSearch={(searchInput) => searchCandidates(currentPage, orderBy, searchInput)}*/}
                            {/*                           onClose={() => setShowSearchInputModal(false)} />*/}
                            <CddSddvListTable candidates={candidates}
                                                onSearchCandidates={
                                                    (page, searchOrderBy) => searchCandidates(page, searchOrderBy)}/>
                            {isLoading && <LoadingView/>}                    
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CddSddvContent; 